import * as React from "react";
// import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Button, Chip, TableCell, TableRow } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import NoAccountsIcon from '@mui/icons-material/NoAccounts';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';

export function Row(props) {
  const {
    row,
    setSelectedUser,
    setShowModalUser,
    setShowModalEditUser,
    setShowModalResetPassword,
    setShowModalDeactivateAccount
  } = props;
  const [open, setOpen] = React.useState(false);
  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        {/* <TableCell component="th" scope="row">
          {row?._id ?? "---"}
        </TableCell> */}
        <TableCell align="center">{row?.firstName ?? "---"}</TableCell>
        <TableCell align="center">{row?.lastName ?? "---"}</TableCell>
        <TableCell align="center">{row?.email}</TableCell>
        {/* <TableCell align="center">{row?.phoneNumber ?? "---"}</TableCell> */}
        <TableCell align="center">
          <Chip
            label={
              row?.status === "active"
                ? "Activa"
                : row?.status === "pending"
                  ? "Pendiente"
                  :row?.status === "inactive" ?"Inactiva": "Cancelada"
            }
            style={{
              backgroundColor:
                row?.status === "active"
                  ? "rgb(5,193,104,20%)"
                  : row?.status === "pending"
                    ? "rgba(238,255,0,20%)"
                    : "rgba(255,90,101,20%)",
              color:
                row?.status === "active"
                  ? "#14CA74"
                  : row?.status === "pending"
                    ? "#EEFF00"
                    : "#FF5A65",
            }}
          />
        </TableCell>
        <TableCell align="center">
          <Chip
            label={row?.membershipStatus === "active" ? "Activa" : row?.membershipStatus === "inactive" ? "Inactiva " : row?.membershipStatus === "expired" ? "Expirada" : "Inactiva"}
            style={{
              backgroundColor:
                row?.membershipStatus === "active"
                  ? "rgb(5,193,104,20%)"
                  : "rgba(255,90,101,20%)",
              color: row?.membershipStatus === "active" ? "#14CA74" : "#FF5A65",
            }}
          />
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Box
                sx={{
                  justifyContent: "center",
                  display: "flex",
                  gap: 4,
                  padding: 2,
                }}
              >
                <Button
                  variant="contained"
                  sx={{ backgroundColor: "#e7ef7d" }}
                  startIcon={<InfoIcon />}
                  onClick={() => {
                    setSelectedUser(row);
                    setShowModalUser(true);
                  }}
                >
                  Detalles
                </Button>
                {
                  row.status !== "inactive" &&
                <Button
                  variant="outlined"
                  sx={{ borderColor: "white", color: "white" }}
                  onClick={() => {
                    // api de desactivacion de cuentas
                    console.log(row);
                    
                    setSelectedUser(row);
                    setShowModalDeactivateAccount(true)
                  }}
                  startIcon={row?.status === "canceled" ?  <PersonAddAltIcon />:<NoAccountsIcon /> }
                >
                  {row?.status === "canceled" ? "Activar cuenta" : "Desactivar cuenta"}
                </Button>
                }

                <Button
                  variant="outlined"
                  sx={{ borderColor: "white", color: "white" }}
                  onClick={() => {
                    setSelectedUser(row);
                    setShowModalEditUser(true);
                  }}
                  startIcon={<ManageAccountsIcon />}
                >
                  Editar
                </Button>

                <Button
                  variant="outlined"
                  sx={{ borderColor: "white", color: "white" }}
                  onClick={() => {
                    setSelectedUser(row);
                    setShowModalResetPassword(true);
                  }}
                  startIcon={<AdminPanelSettingsIcon />}
                >
                  Cambiar contraseña
                </Button>
              </Box>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}
